import { head } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useMasks } from '../_load/MasksLoader'
import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'
import { useMaskActionsList } from '../../_actions/maskActions'

const MultiRowsActions = () => {
  const masks = useMasks()
  const { selecteds, getSelectedData } = useMultiSelectState()
  const { t } = useTranslation()
  const selectedMasks = getSelectedData(masks)
  const menuOptions = useMaskActionsList(head(selectedMasks), selecteds)

  return <MultiSelectMenu t={t} options={menuOptions} />
}

export default MultiRowsActions
